import { PaginationMetadata } from '@models/pagination';

export interface ITransactionsResponse {
  Transactions: ITransactionDetailResponse[];
  pagination_metadata: PaginationMetadata;
}

export interface ITransactionDetailResponse {
  account_amount: number;
  account_balance: number;
  fin_tran_type_id: keyof typeof DriveWealthTransactionType;
  fill_quantity: number;
  fill_price: number;
  instrument: ITransactionInstrument;
  tran_amount: number;
  tran_source: string;
  tran_when: string;
}

export interface ITransactionInstrument {
  id: string;
  symbol: string;
  name: string;
}

export const DriveWealthTransactionType = {
  SPUR: 'Compra',
  SSAL: 'Venta',
};
